import React, { type FC, type PropsWithChildren } from 'react'
import { AppBar, type SxProps, type Theme, Toolbar } from '@mui/material'

import { TOPBAR_HEIGHT } from './Constants'

/** No line under it: the page's white panel below sets it apart */
const appBarStyle: SxProps<Theme> = { backgroundColor: 'grey.100', boxShadow: 0, height: `${TOPBAR_HEIGHT}px` }
const toolbarStyle: SxProps<Theme> = { height: `${TOPBAR_HEIGHT}px`, minHeight: `${TOPBAR_HEIGHT}px` }

/** The `regular` toolbar's min-heights sit in breakpoint and landscape media queries that would win over ours, `dense` has none */
export const TopBar: FC<PropsWithChildren> = ({ children }) => (
    <AppBar position="sticky" sx={appBarStyle}>
        <Toolbar disableGutters variant="dense" sx={toolbarStyle}>
            {children}
        </Toolbar>
    </AppBar>
)
